import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import List from "../components/List.vue";

const routes = [
  {
    path: "/",
    name: "List",
    component: List,
  },
  /*  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ /* "../views/About.vue"),
  }, */
  {
    path: "/:room",
    name: "room",
    component: List,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: "/dist/", //per a que funcione al fer build
  routes,
});

export default router;
